"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusedInputSelectIcon = exports.inputSelectIcon = exports.focusVariations = exports.spinIconLoading = exports.inputVariations = exports.inputIconBase = void 0;

var _stylitas = require("@creditas/stylitas");

var _consts = require("./consts");

const inputIconBase = () => (0, _stylitas.css)`
  display: flex;
  position: absolute;
  width: 24px;
  border-radius: 8px;
  align-items: center;
  pointer-events: none;
  background: transparent;
`;

exports.inputIconBase = inputIconBase;

const inputVariations = ({
  relatedInputType
}) => {
  switch (relatedInputType) {
    case 'input':
      return (0, _stylitas.css)`
        height: 100%;
        margin-right: 12px;
        top: 0;
        left: auto;
        right: 0;
      `;

    case 'select':
      return (0, _stylitas.css)`
        height: 100%;
        top: 0;
        left: auto;
        right: 0;
        align-self: flex-end;
        margin-right: 36px;
      `;

    case 'textarea':
      return (0, _stylitas.css)`
        bottom: 0;
        right: 0;
        margin: 0 12px 16px 0;
      `;

    default:
      return (0, _stylitas.css)``;
  }
};

exports.inputVariations = inputVariations;

const spinIconLoading = ({
  variant
}) => variant === 'loading' && (0, _stylitas.css)`
    ${_stylitas.utilities.animation.spin()};
  `;

exports.spinIconLoading = spinIconLoading;

const focusVariations = ({
  relatedInputType,
  inputFocus,
  readOnly
}) => {
  if (inputFocus && !readOnly) {
    switch (relatedInputType) {
      case 'input':
        return (0, _stylitas.css)`
          margin-right: ${12 - _consts.FOCUSED_BORDER_DELTA}px;
        `;

      case 'select':
        return (0, _stylitas.css)`
          margin-right: ${36 - _consts.FOCUSED_BORDER_DELTA}px;
        `;

      case 'textarea':
        return (0, _stylitas.css)`
          margin: 0 ${12 - _consts.FOCUSED_BORDER_DELTA}px
            ${16 - _consts.FOCUSED_BORDER_DELTA}px 0;
        `;

      default:
        return (0, _stylitas.css)``;
    }
  } else {
    return (0, _stylitas.css)``;
  }
};

exports.focusVariations = focusVariations;

const inputSelectIcon = ({
  selectIcon
}) => selectIcon && (0, _stylitas.css)`
    margin-right: 12px;
  `;

exports.inputSelectIcon = inputSelectIcon;

const focusedInputSelectIcon = ({
  selectIcon,
  inputFocus
}) => selectIcon && inputFocus && (0, _stylitas.css)`
    margin-right: ${12 - _consts.FOCUSED_BORDER_DELTA}px;
  `;

exports.focusedInputSelectIcon = focusedInputSelectIcon;